import baseService from './baseService'

export const userService = {
  login
}

function login (username, password) {
  return baseService.postRequest403Unhandled('api/auth/authenticate', { username: username, password: password })
}
